export default "__VITE_ASSET__M71qyBio__"